import React from 'react';
import { ListView } from 'components';

const App = () => {
  return (
    <div className="App">
      <ListView/>
    </div>
  );
}

export default App;
